import { Tooltip } from "@safetyculture/sc-web-ui";
import styled from "styled-components";
import { theme } from "../../../styles/themes";

export const InfoOnHoverWrapper = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.color.accent.text.default.default};
  padding: 0 10px;
`;

export const StyledTooltip = styled(Tooltip)`
  max-width: 50rem;
  text-align: justify;
`;
